export const SELLER_ACCOUNT_OFFERS_SORT = 'SELLER_ACCOUNT_OFFERS_SORT';
export const SELLER_ACCOUNT_BUYERS_SORT = 'SELLER_ACCOUNT_BUYERS_SORT';
export const ACTIVE_BUYER = 'ACTIVE_BUYER';
export const ACTIVE_BUYER_TYPE = 'ACTIVE_BUYER_TYPE';